import { AxiosError } from 'axios';
import { PaginatedData } from 'web-library/models/List';
import { POST_ACCOUNT_MANAGEMENT_LISTING_URL } from 'web-library/constants/apiUrls';
import {
  AccountManagementListingContentObject,
  AccountManagementListingRequest,
} from 'web-library/models/UserGroupAccessConfiguration/UserGroupAccessConfiguration';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: PaginatedData<AccountManagementListingContentObject>) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  accountType: string;
}

export const usePostAccountManagementListing = ({ onSuccess, onError, accountType }: Input) => {
  const postAccountManagementListing = async (reqBody: AccountManagementListingRequest) => {
    const res = await axiosClient.post<PaginatedData<AccountManagementListingContentObject>>(
      POST_ACCOUNT_MANAGEMENT_LISTING_URL(accountType, reqBody.apiPathParam),
      {
        organization: reqBody.organization,
        status: reqBody.status,
        q: reqBody.q,
      }
    );
    return res.data;
  };

  return useCustomMutation(
    postAccountManagementListing,
    {
      onSuccess,
      onError,
    },
    true,
    false
  );
};
